module.exports = __webpack_public_path__ + "post-listing-cross-promotoe-ico-2-39FTSYH.png";